"use strict";

import "core-js/modules/es.regexp.to-string.js";
import { getDataDogRUM } from '@autoguru/logs/datadog/agent';
import { useEffect } from 'react';
export const useDataDogUserIdentification = viewer => {
  useEffect(() => {
    if (!process.__browser__) return;
    if (!(viewer !== null && viewer !== void 0 && viewer.dbId)) return;
    try {
      const datadogRUM = getDataDogRUM();
      if (datadogRUM) {
        datadogRUM.setUser({
          id: viewer.dbId.toString(),
          email: viewer.emailAddress || undefined,
          name: viewer.fullName || undefined,
          firstName: viewer.firstName || undefined,
          lastName: viewer.lastName || undefined,
          team: viewer.team || undefined
        });
        if (process.env.NODE_ENV !== "production") {
          console.log('[DataDog] User identified:', viewer.dbId);
        }
      }
    } catch (error) {
      if (process.env.NODE_ENV !== "production") {
        console.warn('[DataDog] setUser failed:', error);
      }
    }
  }, [viewer === null || viewer === void 0 ? void 0 : viewer.dbId, viewer === null || viewer === void 0 ? void 0 : viewer.emailAddress, viewer === null || viewer === void 0 ? void 0 : viewer.fullName, viewer === null || viewer === void 0 ? void 0 : viewer.firstName, viewer === null || viewer === void 0 ? void 0 : viewer.lastName, viewer === null || viewer === void 0 ? void 0 : viewer.team]);
};